var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.configData.show && _vm.showGoTop)?_c('div',{staticClass:"goTop",on:{"click":_vm.scrollToTop}},[_c('template-button',{attrs:{"btn-config":_vm.configData,"default-height":'50px',"default-width":'50px'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }